import { useGetColor } from 'hooks';
import { useId } from 'react';

import type { IconPropsType } from './types';

export const LogoIcon = ({
  color,
  size,
  width = 23,
  height = 25,
  ...props
}: IconPropsType) => {
  const id = useId();
  const iconColor = useGetColor(color);

  return (
    <svg
      width={size ? '100%' : width}
      height={size ?? height}
      viewBox="0 0 23 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <clipPath id={`${id}_a`}>
          <path d="M2000,0 L2000,1102 L0,1102 L0,0 L2000,0 Z" />
        </clipPath>
        <clipPath id={`${id}_b`}>
          <path d="M22.097561,0 L22.097561,24 L0,24 L0,0 L22.097561,0 Z" />
        </clipPath>
        <clipPath id={`${id}_c`}>
          <path d="M10.4065577,0 C13.5751193,0 16.2597915,2.11770262 17.1201818,5.01236744 C18.2212348,5.33877414 19.2301992,5.94000134 20.0642075,6.78147756 C21.3763574,8.10541181 22.0984698,9.86547244 22.097561,11.7373796 C22.0956166,15.5981282 18.9543467,18.7391306 15.0952234,18.7391306 L8.0317285,18.7391306 L8.0317285,21.2032155 C8.0317285,22.2866922 7.43019553,23.2513581 6.46187919,23.7207632 C6.07557816,23.9079664 5.66463194,24 5.2569938,24 C4.64284877,24 4.03614692,23.7911573 3.53191284,23.3843061 L1.30276321,21.5858374 C0.474833516,20.9179276 0,19.9215677 0,18.8522699 L0,4.64104699 C0,2.08196344 2.06440725,0 4.60191128,0 L10.4065577,0 Z M5.86080108,14.0105914 L2.17092742,14.0105914 L2.17092742,18.8522699 C2.17092742,19.2527822 2.34877807,19.626021 2.65886921,19.8761952 L4.88806019,21.674664 C5.15349225,21.8888072 5.45006161,21.7809641 5.55207452,21.731463 C5.65408744,21.6820454 5.86080108,21.5459279 5.86080108,21.2032155 L5.86080108,14.0105914 Z M17.3933465,7.4790379 C17.2821123,9.17133172 16.5755891,10.7468164 15.3755418,11.9576113 C14.0634746,13.2815039 12.3186692,14.0105914 10.4626297,14.0105914 L8.0317285,14.0105914 L8.0317285,16.5497411 L15.0952234,16.5497411 C17.7578969,16.5497411 19.9252681,14.3904192 19.9266333,11.7362536 C19.927253,10.449393 19.4307929,9.23939045 18.5287622,8.32922997 C18.1886089,7.9860588 17.8061948,7.70102114 17.3933465,7.4790379 Z M10.4065577,2.18938949 L4.60191128,2.18938949 C3.26147731,2.18938949 2.17092742,3.28921366 2.17092742,4.64104699 L2.17092742,11.8212019 L5.86080108,11.8212019 L5.86080108,9.36954445 C5.86080108,6.8104609 7.92524968,4.72849746 10.4627537,4.72849746 L14.6629814,4.72849746 C13.8465059,3.21831914 12.2444442,2.18938949 10.4065577,2.18938949 Z M15.1512953,6.91788695 L10.4627537,6.91788695 C9.12227839,6.91788695 8.0317285,8.01766942 8.0317285,9.36954445 L8.0317285,11.8212019 L10.4626297,11.8212019 C11.7385974,11.8212019 12.9380658,11.3199777 13.8400965,10.4098589 C14.7421685,9.49969844 15.2385873,8.28969585 15.2379263,7.00279356 L15.23714,6.9186376 C15.2085665,6.91813716 15.1799929,6.91788695 15.1512953,6.91788695 Z" />
        </clipPath>
      </defs>
      <g transform="translate(-323.0 -632.0)">
        <g clipPath={`url(#${id}_a)`}>
          <g transform="translate(307.0 612.5)">
            <g transform="translate(15.999999999999961 20.0)">
              <g clipPath={`url(#${id}_b)`}>
                <g transform="translate(0.0 -4.170265691882946e-06)">
                  <g clipPath={`url(#${id}_c)`}>
                    <polygon
                      points="0,4.1702657e-06 22.097561,4.1702657e-06 22.097561,24 0,24 0,4.1702657e-06"
                      stroke="none"
                      fill={iconColor}
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
